@if (hasNotes) {
  <div fxLayout="column">
    @for (note of model; track note) {
      @if (!note.IsDeleted) {
        <note [hideSubject]="hideSubject" [model]="note" (onDelete)="deleteNote(note)" [viewOnly]="viewOnly">
        </note>
      }
    }
  </div>
} @else {
  <div fxLayout="column" fxLayoutAlign="center center">
    <img alt="Illustration of blank notebook paper" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/notes-empty-state-spot-hero.svg" style="width: 350px; height: 350px;">
    <div class="forge-typography--heading2">
      The notebook is empty.
    </div>
  </div>
}

